export default __webpack_public_path__ + "assets/desert_cactus-4e46bdd.svg";